export default "__VITE_ASSET__dc80f341__"